export enum CardTypeEnum {
	Visa,
	Mastercard,
	Amex,
	Discover,
	Diners,
	JCB,
	VisaElectron
}
